var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#3030AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6942 34.1536L30.1301 28.5852C31.7663 26.5537 32.5612 23.9722 32.3514 21.3722C32.1415 18.7722 30.9428 16.3516 29.002 14.6088C27.0612 12.866 24.5261 11.9337 21.9186 12.0037C19.3111 12.0737 16.8297 13.1408 14.9852 14.9852C13.1408 16.8297 12.0737 19.3111 12.0037 21.9186C11.9337 24.5261 12.866 27.0612 14.6088 29.002C16.3516 30.9428 18.7722 32.1415 21.3722 32.3514C23.9722 32.5612 26.5537 31.7663 28.5852 30.1301L34.1536 35.6985C34.3591 35.897 34.6343 36.0068 34.92 36.0043C35.2056 36.0018 35.4789 35.8873 35.6809 35.6853C35.8829 35.4833 35.9975 35.21 36 34.9243C36.0024 34.6387 35.8926 34.3635 35.6942 34.158V34.1536ZM14.2235 22.2128C14.2235 20.6324 14.6922 19.0875 15.5702 17.7735C16.4483 16.4594 17.6962 15.4353 19.1563 14.8306C20.6165 14.2258 22.2231 14.0677 23.7731 14.376C25.3231 14.6844 26.7469 15.4456 27.8643 16.5631C28.9817 17.6807 29.7426 19.1046 30.0508 20.6546C30.359 22.2047 30.2006 23.8113 29.5957 25.2713C28.9907 26.7313 27.9664 27.9792 26.6523 28.857C25.3381 29.7349 23.7932 30.2033 22.2128 30.2031C20.0945 30.2005 18.0638 29.3578 16.566 27.8599C15.0683 26.3619 14.2258 24.3311 14.2235 22.2128Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchIcon.7d028870742c108ea8d2f05342a8c392.svg";